export default __webpack_public_path__ + "static/media/date.fd53fa50.svg";